import React from 'react';

type Props = {
};

export const IcGoldToken = (props: Props) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="28" height="28" rx="14" transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 0)" fill="white" fill-opacity="0.15"/>
      <path d="M14 9.1001C10.5217 9.1001 7 10.1823 7 12.2501C7 14.3179 10.5217 15.4001 14 15.4001C17.479 15.4001 21 14.3179 21 12.2501C21 10.1823 17.479 9.1001 14 9.1001ZM10.5 16.0567V18.1567C11.3659 18.366 12.3235 18.4941 13.3 18.5354V16.4354C12.3567 16.3987 11.4191 16.2718 10.5 16.0567ZM14.7 16.4347V18.5347C15.6433 18.4987 16.581 18.3719 17.5 18.156V16.056C16.581 16.2719 15.6433 16.3987 14.7 16.4347ZM18.9 15.608V17.708C20.1607 17.1795 21 16.4081 21 15.4001V13.3001C21 14.3081 20.1607 15.0795 18.9 15.608ZM9.1 17.708V15.608C7.84 15.0795 7 14.3074 7 13.3001V15.4001C7 16.4074 7.84 17.1795 9.1 17.708Z" fill="url(#paint0_linear_23169_15673)"/>
      <defs>
        <linearGradient id="paint0_linear_23169_15673" x1="7" y1="13.8177" x2="21" y2="13.8177" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFE259"/>
          <stop offset="1" stop-color="#FFA751"/>
        </linearGradient>
      </defs>
    </svg>
  );
};
